import React from 'react';

//https://reactjs.org/docs/lists-and-keys.html#extracting-components-with-keys
class OfferItem extends React.Component {
	
	render() {

		let value = this.props.value;

		if(this.props.type == 'percentage'){
			value = value + '%';
		} else if (this.props.type == 'amount') {
			value = value + wp_core.currency;
		}

		return (
			<li className="box-content offer__item">	
				<div className="box__body center">	
					<h3 className="offer__name">{this.props.title}</h3>
					<h4 className={`offer__value ${this.props.type}`}>{value}</h4>
					<p>{this.props.desc}</p>
				</div>
			</li>
		);
	}
}

export default OfferItem;